<script lang="ts">
  import { haptic } from "../lib/tg";

  let { onpress, busy = false }: { onpress?: () => void; busy?: boolean } = $props();

  function handleClick() {
    if (busy) return;
    haptic("light");
    onpress?.();
  }
</script>

<button class="txt" class:busy onclick={handleClick} disabled={busy} aria-label="Команда текстом">
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
</button>

<style>
  .txt {
    position: fixed;
    right: 18px;
    bottom: calc(88px + var(--safe-bottom, 0px));
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: var(--bg-elev);
    color: var(--brass);
    border: 1px solid var(--border-strong);
    box-shadow: var(--shadow-md);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 49;
    transition: transform 120ms ease;
  }
  .txt:active { transform: scale(0.94); }
  .txt.busy { opacity: 0.6; cursor: wait; }
  .txt svg { width: 22px; height: 22px; }
</style>
